export default __webpack_public_path__ + "assets/images/d85f8e68760d4eed40ac3f1e3e1961a8.png";